import { useParams } from "common/components/Form/ParamsContext";
import { useFilter } from "components/FilterProvider";
import { useMemo } from "react";
import {
  BookingDocumentType,
  getBookingDocumentService,
} from "./bookingDocumentApi";

export type BookingDocumentFilter = {
  range?: { start?: string; end?: string };
  boatIds?: number[];
  programIds?: number[];
};

export default function useBookingDocumentList(type?: BookingDocumentType) {
  const params = useParams<"booking_id">();
  const scope = params.booking_id ? { bookings: params.booking_id } : undefined;
  const urlParams = type ? { type } : undefined;
  const service = getBookingDocumentService(scope, urlParams);

  const [filter, onChange] = useFilter<BookingDocumentFilter>();

  const gridFilter = useMemo(() => {
    const f: any[] = [];

    if (filter?.range?.start && filter?.range?.end) {
      f.push({
        columnField: "event_group.start_time",
        operatorValue: "between",
        value: [filter.range.start, `${filter.range.end} 23:59:59`],
      });
    }

    if (filter?.boatIds && filter.boatIds.length > 0) {
      f.push({
        columnField: "event_group.boat_id",
        operatorValue: "in",
        value: filter.boatIds,
      });
    }

    if (filter?.programIds && filter.programIds.length > 0) {
      f.push({
        columnField: "event.program_id",
        operatorValue: "in",
        value: filter.programIds,
      });
    }

    return f;
  }, [filter]);

  return { ...service, params, scope, filter, onChange, gridFilter };
}
